import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'

export default {
  extends: FormSelect,
  props: {
    placeholder: {
      type: String,
      default: 'Type to search for terms',
    },
    config: {
      type: Object,
      default: () => ({
        multiple: true,
        searchable: true,
        showHistoricalTerms: false,
      }),
    },
  },
  inject: {
    fetchOptionsOnMount: {
      type: Boolean,
      default: () => (false),
    },
    excludeOptions: {
      type: Array,
      default: () => ([]),
    },
    setAvailableOptions: {
      type: Function,
      default: () => (null),
    },
  },
  mounted () {
    if (this.fetchOptionsOnMount) { this.getTerms(true) }
  },
  created () {
    this.getTerms()
  },

  computed: {
    ...mapGetters([
      'terms',
      'termsWithHistorical',
      'termDisplayName',
      'school',
    ]),
    normalizedOptions () {
      let options = this.config.showHistoricalTerms ? this.termsWithHistorical : this.terms

      if (this.excludeOptions?.value) {
        options = options.filter(option => !this.excludeOptions.value.includes(this.termDisplayName(option)))
      }
      // If config.optionsFromAction is non-blank array then some action is triggered
      // and options are filtered based on actions
      const optionsFromAction = this.mergedConfig.optionsFromAction
      if (optionsFromAction && optionsFromAction.length > 0) {
        options = options.filter(option => optionsFromAction.includes(this.termDisplayName(option)))
      }

      return options
    },
    objValue () {
      if (this.config.trackBy) {
        return Array.isArray(this.value)
          ? this.value.map(value => this.flatOptions.find(option => option[this.config.trackBy] === value))
          : this.flatOptions.find(option => option[this.config.trackBy] === this.value) || this.value
      } else {
        return this.value
      }
    },
  },
  watch: {
    normalizedOptions: {
      handler (options) {
        if (!this.setAvailableOptions || typeof this.setAvailableOptions !== 'function') { return }
        this.setAvailableOptions(options)
      },
    },
  },
  methods: {
    normalizedOptionLabel (term) {
      if (!term) return ''
      return this.termDisplayName(term) || term.id || term
    },
    getTerms (forceReload = false) {
      this.$store.dispatch('loadTerms', {
        school: this.school,
        ...(this.config.showHistoricalTerms
          ? { filterHistorical: false }
          : undefined),
        forceReload,
      })
    },
  },
}
